module.exports = __webpack_public_path__ + "static/logo-a11y-3a13fdc82b1529c7d0ca43fefe61d6ac.png";